import { createApp } from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import router from "./router";
import store from "./store";

import "@/../scss/custom.scss";
import "bootstrap";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

import AOS from "aos";
import "aos/dist/aos.css";

const app = createApp(App);

app.use(i18n);
app.use(store);
app.use(router);

// ✅ 先初始化 AOS（在 mount 前）
AOS.init({
  duration: 700,
  easing: "ease-out-cubic",
  offset: 80,
  once: true,
  mirror: false,
});

// ✅ 路由切換後 refresh（等 DOM 更新完再 refresh）
router.afterEach(() => {
  requestAnimationFrame(() => {
    AOS.refreshHard(); // refreshHard 比 refresh 更乾淨（會重算所有）
  });
});

// ✅ 最後再 mount
app.mount("#app");

// ✅ 保險：首次 mount 後也 refresh 一下（避免首屏剛好沒算到）
requestAnimationFrame(() => {
  AOS.refreshHard();
});
